"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kartonJson = void 0;
const VerpackungModel_1 = require("./VerpackungModel");
exports.kartonJson = {
    EntityId: '1509014752549_3194906',
    ArtNrExists: false,
    ArtNrGenerated: 'CUSTOMTEST',
    Bezeichnung: { 'de-DE': 'custom bezeichnung' },
    Preis: { Countries: { DE: { EUR: 12 } } },
    Typ: VerpackungModel_1.VerpackungType.karton,
    Verpackungsmittel: 'Karton',
    Laenge: { Unit: 'mm', Value: 7 },
    Breite: { Unit: 'mm', Value: 3 },
};
//# sourceMappingURL=kartonJson.js.map